import { render, staticRenderFns } from "./Workpage.vue?vue&type=template&id=d385e13c&"
import script from "./Workpage.vue?vue&type=script&lang=js&"
export * from "./Workpage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports